document.domain = 'plaync.com';

(function (_win) {
	var siteURL = window.cert_doamin;
	var isMobile =  document.body.classList.contains('mobile');

	var Cert = new function () {
		var childWindow = null;

		return {
			openCertWindow: function (hash, isCertPopup, isInternal, isAuthModulePopup, hasOpener) {
				// console.log( 'cert.js openCertWindow() hash..... : ', hash, isCertPopup, isInternal, isAuthModulePopup, hasOpener );
				this.openWindow(hash, isCertPopup, isInternal, isAuthModulePopup, hasOpener);
			},
			openWindow: function (hash, isCertPopup, isInternal, isAuthModulePopup, hasOpener) {

				// console.log( 'cert.js openWindow() hash..... : ', hash, isCertPopup, isInternal, isAuthModulePopup, hasOpener );

				if (isCertPopup == null) {
					isCertPopup = true;
				}
				if (isMobile) {
					isCertPopup = false;
				} else {
					isCertPopup = true;
				}

				if (isInternal == null) {
					isInternal = false;
				}

				if (isAuthModulePopup == null) {
					isAuthModulePopup = true;
				}

				if (hasOpener == null) {
					hasOpener = true;
				}

				var internal = isInternal ? '1' : '0';
				var http = location.href.match(/^http:\/\//i) != null ? '1' : '0';
				var url = siteURL + '/cert/main/intro?q=' + hash + '&internal=' + internal + '&http=' + http + '&authmodulepopup=' + isAuthModulePopup + '&opener=' + hasOpener;
				var formurl = siteURL + '/cert/main/intro';


				if (isCertPopup) {
					var windowName = !isInternal ? '__sp_win_request' : '__sp_win_internal';
					childWindow = window.open('about:blank', windowName, 'width=450, height=500, resizable=0, scrollbars=no, status=0, titlebar=0, toolbar=0');
					this.submitForm(formurl, windowName, hash, internal, http, isAuthModulePopup, hasOpener);
				} else {
					this.closeChildWindow();
					location.href = url;
				}

				// console.log('cert.js openWindow() url, formurl : ',  url, formurl );

			},
			closeChildWindow: function () {
				if (childWindow) {
					childWindow.close();
				}
			},
			sendResult: function (returnUrl, callback, hash) {
				if (returnUrl !== '') {
					setTimeout(function () {
						location.href = returnUrl + '?q=' + hash;
					}, 0);
				} else {
					setTimeout(callback + '(\'' + hash + '\')', 0);
				}
			},
			login: function (loginUrl) {
				setTimeout(function () {
					var url = loginUrl + encodeURIComponent(location.href);
					try {
						if (opener) {
							return;
						}
					} catch (e) {
            //
					}

					location.href = url;
				}, 0);
			},
			submitForm: function (url, tgname, hash, internal, http, isAuthModulePopup, hasOpener) {
				function formCreate(tg, mt, at) {
					var fo = document.createElement('form');
					fo.target = tg;
					fo.method = mt;
					fo.action = at;
					return fo;
				}

				function formInput(fo, na, va) {
					var inp = document.createElement('input');
					inp.type = 'hidden';
					inp.name = na;
					inp.value = va;
					fo.insertBefore(inp, null);
					return fo;
				}

				var frm = formCreate(tgname, 'post', url);
				frm = formInput(frm, 'q', hash);
				frm = formInput(frm, 'internal', internal);
				frm = formInput(frm, 'http', http);
				frm = formInput(frm, 'authmodulepopup', isAuthModulePopup);
				frm = formInput(frm, 'opener', hasOpener);
				document.body.appendChild(frm);
				frm.submit();

				// console.log('cert.js submitForm() url : ',  url );

			},
			redirect: function (redirectUrl) {
				setTimeout(function () {
					var url = redirectUrl;
					try {
						if (opener) {
							return;
						}
					} catch (e) {
            //
					}

					location.href = url;
				}, 0);
			}
		};
	};

	_win.Cert = Cert;
})(window);
